import React from "react";

const tracksData = [
  {
    trackTitle: "Artificial Intelligence and Machine Learning",
    description:
      "Explore advances in AI and ML, including reinforcement learning, neural networks, and applications in robotics, NLP, and computer vision.",
    icon: "bi-cpu",
  },
  {
    trackTitle: "Digital Security, Information Privacy and Web Technology",
    description:
      "Delve into the latest enhancements in web security frameworks, encryption techniques, and safeguarding digital communications.",
    icon: "bi-shield-lock",
  },
  {
    trackTitle: "Internet of Everything and Sensor Networks",
    description:
      "Focus on the integration of IoT systems with sensor networks, addressing security issues and smart environment applications.",
    icon: "bi-wifi",
  },
  {
    trackTitle: "Healthcare Analytics, CoVID-19 Technologies and Data Analysis",
    description:
      "Discover how data analytics is revolutionizing healthcare, with applications in predictive models, healthcare data privacy, and CoVID-19 innovations.",
    icon: "bi-graph-up",
  },
  {
    trackTitle: "Software Engineering and Cloud Computing",
    description:
      "Examine innovations in software development methodologies, cloud platforms, and cloud-native architectures driving the future.",
    icon: "bi-cloud-arrow-up",
  },
  {
    trackTitle: "Digital Image and Video Processing",
    description:
      "Advancements in image recognition, video analytics, and pattern recognition are transforming fields like computer vision and video processing.",
    icon: "bi-camera-reels",
  },
  {
    trackTitle: "Circuits and Systems and Quantum Computing",
    description:
      "Learn about cutting-edge circuit designs, VLSI, and quantum computing principles and their impact on cryptography and communication.",
    icon: "bi-cpu",
  },
  {
    trackTitle: "Communication Technologies",
    description:
      "Stay updated on recent trends in 5G/6G, satellite communications, and advancements in wireless and optical communication.",
    icon: "bi-broadcast",
  },
  {
    trackTitle: "E-Commerce and E-Governance",
    description:
      "Discover emerging trends in digital transactions, blockchain in governance, and the future of secure payment systems.",
    icon: "bi-wallet",
  },
];

const Tracks = () => {
  return (
    <div>
      <section
        id="tracks"
        className="services section section-bg dark-background"
      >
        <div className="container section-title" data-aos="fade-up">
          <h2 className="text-white">Tracks</h2>
          <p className="text-white"></p>
        </div>

        <div className="container">
          <div className="row gy-4">
            {tracksData.map((track, index) => (
              <div
                className="col-md-6"
                data-aos="fade-up"
                data-aos-delay={100 * (index + 1)}
                key={index}
              >
                <div className="service-item d-flex position-relative h-100">
                  <i className={`bi ${track.icon} icon flex-shrink-0`}></i>
                  <div>
                    <h4 className="title">
                      <a href="#" className="stretched-link">
                        {track.trackTitle}
                      </a>
                    </h4>
                    <p className="description">{track.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Tracks;
